export class DeletePersonaRequest {

    public id_Persona: number = 0;

}
